import { render, staticRenderFns } from "./DashboardAction.vue?vue&type=template&id=7c1ca0ab&"
import script from "./DashboardAction.vue?vue&type=script&lang=ts&"
export * from "./DashboardAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports